import Routes from './Routes';
import history from './history';
import InnerRoutes from './InnerRoutes';

export default Routes;
export { history, InnerRoutes };
